<template>
  <ui-textarea
    v-model="comment"
    height="120"
    :label="label"
    placeholder="Комментарий к заказу"
    class="checkout-comment"
    @input="saveComment"
  />
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import { debounce } from 'throttle-debounce';

export default {
  name: 'checkout-comment',

  props: {
    label: {
      type: String,
      default: 'Комментарий',
    }
  },

  computed: {
    ...mapState({
      COMMENT: state => state.cart.comment,
    }),

    comment: {
      get() {
        return this.COMMENT;
      },
      set(value) {
        this.SET_COMMENT(value);
      },
    },
  },

  methods: {
    ...mapMutations({
      SET_COMMENT: 'cart/setComment',
    }),
    ...mapActions({
      SAVE_COMMENT: 'cart/saveComment',
    }),
    ...mapMutations('cart', ['setProgress']),

    debouncedSaveComment: debounce(1000, false, function (comment) {
      this.SAVE_COMMENT({ comment });
    }),

    saveComment(comment) {
      this.setProgress();
      this.debouncedSaveComment(comment);
    },
  },
};
</script>
